import { render, staticRenderFns } from "./SkillExpandable.vue?vue&type=template&id=5cbd2276&scoped=true&"
import script from "./SkillExpandable.vue?vue&type=script&lang=js&"
export * from "./SkillExpandable.vue?vue&type=script&lang=js&"
import style0 from "./SkillExpandable.vue?vue&type=style&index=0&id=5cbd2276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd2276",
  null
  
)

export default component.exports